import * as React from "react";
import { FontIcon, IStackStyles, mergeStyles, Stack, Text } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import * as Messages from "../../codegen/Messages";
import { MetaItemGroupsLayout, MetaItemGroupsLayoutProps } from "./MetaItemGroupsLayout";

const OPEN_ICON = "ChevronDownSmall";
const CLOSE_ICON = "ChevronUpSmall";

export interface MetaItemSectionProps extends MetaItemGroupsLayoutProps {
  /**
   * Title for the MetaItemGroup
   * @default Essentials
   */
  title?: string;
}

const metaInfoStackStyle: IStackStyles = {
  root: {
    minWidth: "760px",
    gridGap: "10px",
    margin: "10px 0px",
    borderBottom: "1px solid rgb(214, 214, 214)",
    paddingBottom: "10px",
  },
};

const toggleIconClass = mergeStyles({ fontSize: 15, width: 15, cursor: "pointer" });

/**
 * MetaItemSection renders the component(s) group by item sections
 */

export const MetaItemSection = ({
  title = Messages.labels.essentials(),
  ...rest
}: MetaItemSectionProps): JSX.Element => {
  const [hideSection, { toggle: toggleSection }] = useBoolean(false);

  return (
    <Stack styles={metaInfoStackStyle}>
      <Stack horizontal horizontalAlign="space-between">
        <Stack onClick={toggleSection} horizontal tokens={{ childrenGap: 10 }}>
          <FontIcon iconName={hideSection ? OPEN_ICON : CLOSE_ICON} className={toggleIconClass} />
          <Text variant="medium" style={{ fontWeight: "bold" }}>{title}</Text>
        </Stack>
      </Stack>
      {!hideSection && <MetaItemGroupsLayout {...rest} />}
    </Stack>
  );
};
